// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import {
    Avatar,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";



// main function
export default function MultiGoodContractAvatar({ rowContractData }) {


    return (

        <Box>
            {
                ((rowContractData.comboStatus === 'm') && (rowContractData.inputMissingRollup === 0 || rowContractData.inputMissingRollup === '' || rowContractData.inputMissingRollup === null  )
                )
                &&
                <div >
                    <Tooltip
                        enterDelay={1000}
                        title="MultiGoodContractAvatar"
                    >
                    <Avatar sx={{height: 20, width: 20, fontSize: 14,  bgcolor: 'rgb(0,128,0)'}}>m
                    </Avatar>
                    </Tooltip>
                </div>}
        </Box>

    )

}
